import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetTermsQuery } from '@/store/api/termsApi'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'
import { CourseFilterCheckboxGroup } from './CourseFilterCheckboxGroup'
import { FilterDrawerType, FilterType } from './types'
import { CourseFilterAccordion } from '../CourseFilterAccordion/CourseFilterAccordion'

type Props = {
  type: FilterDrawerType
  onChange: (filterType: FilterType, value: string) => void
}

export const CourseFilterTerm = ({ type, onChange }: Props) => {
  const { t } = useTranslation()

  const filters = useAppSelector((state) => createFiltersSelector(state, type))
  const termIds = useAppSelector((state) => state.aggregates.termIds)

  const { data: termsData, isLoading: isTermsLoading } = useGetTermsQuery()

  const termOptions = useMemo(
    () =>
      (termsData || [])
        .filter((term) => termIds.includes(term.id))
        .map((term) => ({ label: term.name, value: term.id })),
    [termIds, termsData],
  )

  if (isTermsLoading || !termOptions.length) {
    return null
  }

  return (
    <CourseFilterAccordion
      title={t('coursesFilterDrawer.term')}
      badgeCount={filters.term.length}
      testId="course-filter-term"
    >
      <CourseFilterCheckboxGroup<string>
        filterType="term"
        options={termOptions}
        filters={filters}
        onChange={onChange}
        isLoading={isTermsLoading}
      />
    </CourseFilterAccordion>
  )
}
